// API service functions for "people" (profiles).
// A person is a named profile owned by the account - NOT a login. The same
// profiles are used by the macro calculator and the workout tracker, so this
// service is feature-neutral.

const API_URL = process.env.REACT_APP_API_URL;

const BASE = `${API_URL}/api/people`;

// Throws an Error carrying the server's message and status so callers can
// distinguish 403 (person deleted / not ours) from a generic failure.
const handle = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return data;
};

export const peopleAPI = {
  // -> { people: [{ id, name, color, icon, is_default, sort_order }], defaultPersonId }
  list: () => fetch(BASE, { credentials: "include" }).then(handle),

  create: ({ name, color, icon }) =>
    fetch(BASE, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, color, icon })
    }).then(handle),

  update: (id, fields) =>
    fetch(`${BASE}/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fields)
    }).then(handle),

  reorder: (personIds) =>
    fetch(`${BASE}/reorder`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ personIds })
    }).then(handle),

  // Counts of what a delete would remove - powers the confirmation dialog
  stats: (id) => fetch(`${BASE}/${id}/stats`, { credentials: "include" }).then(handle),

  // confirmName must match the person's name exactly (server-enforced)
  remove: (id, confirmName) =>
    fetch(`${BASE}/${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ confirm_name: confirmName })
    }).then(handle)
};

export default peopleAPI;
